import { Image, Col, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const KeywordDetails = ({
  KeywordDetails,
}: {
  KeywordDetails: any;
}): ReactElement => {
  const [getKeywordDetails, setKeywordDetails] = useState(undefined);

  useEffect(() => {
    // BannerDetails();
    setKeywordDetails(KeywordDetails);
  }, [KeywordDetails]);

  return (
    <React.Fragment>
      <div className="user-deatils-area">
        <Tab.Container id="left-tabs-example" defaultActiveKey="basic">
          <Row gutter={5}>
            <Col span={24}>
              <div className="user-detals-wrapper-content">
                <div className="user-details-inner-content">
                  <div className="user-image-content">
                    <div className="banner-img px-3">
                      <Image
                        height={300}
                        src={getKeywordDetails?.productImage}
                        className="rounded"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col span={24} style={{ background: "#fff" }}>
              <div className="user-information-show-tab-wrapper">
                <div className="inner-content">
                  <div className="single-content">
                    <Tab.Content>
                      <Tab.Pane eventKey="basic">
                        <React.Fragment>
                          <div className="single-information-user-wrapper mb-3">
                            <div className="single-information-user-content">
                              <div className="info-body user-personal-inforamtion">
                                <h3 className="title">Basic Information</h3>
                                <div className="inner-body-wrapper">
                                  <div className="inner-body">
                                    <div className="single">
                                      <div className="info-name">
                                        <span>Product</span>
                                      </div>
                                      <div className="info-desc">
                                        <span className="text-uppercase font-weight-600">
                                          {getKeywordDetails?.name}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="single">
                                      <div className="info-name">
                                        <span>Keyword</span>
                                      </div>
                                      <div className="info-desc">
                                        <span>
                                          {getKeywordDetails?.keyword}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="single">
                                      <div className="info-name">
                                        <span>Type</span>
                                      </div>

                                      <div className="info-desc">
                                        <span>{`${getKeywordDetails?.type?.replace(
                                          "_",
                                          " "
                                        )}`}</span>
                                      </div>
                                    </div>

                                    <div className="single">
                                      <div className="info-name">
                                        <span>Status</span>
                                      </div>
                                      <div className="info-desc">
                                        <span
                                          className={`radius-btn ${
                                            getKeywordDetails?.deleted
                                              ? "inactive"
                                              : "active"
                                          }-btn`}
                                        >
                                          {getKeywordDetails?.deleted
                                            ? "Inactive"
                                            : "Active"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </React.Fragment>
  );
};
KeywordDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default KeywordDetails;
